import * as React from "react";
import { Icon, IconInput } from "./Icon";

/**
 * The page title block — duotone icon, heading, subtitle, bottom rule — that ScadsysIdentity repeats
 * by hand in organizations/Index.tsx and clients/ClientsTable.tsx. `actions` covers the primary
 * button those pages float on the right.
 */

export interface PageHeaderProps {
    title: string;
    description?: React.ReactNode;
    icon?: IconInput;
    iconColor?: string;
    actions?: React.ReactNode;
    className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    description,
    icon,
    iconColor = "text-primary",
    actions,
    className = "",
}) => (
    <div className={`mb-6 flex flex-wrap items-start justify-between gap-4 border-b border-border pb-4 ${className}`}>
        <div className="flex items-start gap-3">
            {icon && <Icon icon={icon} className={`mt-1 text-3xl ${iconColor}`} />}
            <div>
                <h2 className="text-2xl font-semibold text-text-strong">{title}</h2>
                {description && <p className="mt-1 text-sm text-text-weak">{description}</p>}
            </div>
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
);

/** A lighter heading for sections inside a page. */
export const SectionHeader: React.FC<{ title: string; description?: React.ReactNode; actions?: React.ReactNode }> = ({
    title,
    description,
    actions,
}) => (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <div>
            <h3 className="text-base font-semibold text-text-strong">{title}</h3>
            {description && <p className="text-xs text-text-weak">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
);

export default PageHeader;
